import React from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
} from '@sitecore-jss/sitecore-jss-react';
import { Grid, GridSize } from '@material-ui/core';
import './index.scss';

/**
 * TODO: Move to global folder
 * TODO: Remove SnowDragon Ref in title
 * Shared SnowDragon component props
 */
export type SnowDragonComponentProps = {
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
};

const TwoColumnContentRow = (props: SnowDragonComponentProps): JSX.Element => {
  let col1: GridSize = 6;
  let col2: GridSize = 6;
  let rowConfig = props?.params?.['Content Row Column Configuration'];

  if (rowConfig) {
    if (rowConfig === '1 to 2') {
      col1 = 4;
      col2 = 8;
    } else if (rowConfig === '2 to 1') {
      col1 = 8;
      col2 = 4;
    } else {
      // Default to 1 to 1 if value is not recognized
    }
  }

  return (
    <>
      <Grid container alignItems="stretch" className="two-column-content-row content-row" xs={12}>
        <Grid item xs={12} md={col1}>
          <div>
            <Placeholder name="column_one" rendering={props.rendering} />
          </div>
        </Grid>
        <Grid item xs={12} md={col2}>
          <div>
            <Placeholder name="column_two" rendering={props.rendering} />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default TwoColumnContentRow;
